const OutputTypes = {
  current_scale_pitch_class: {
      name: "Scale Pitch Class",
      index: "current_scale_pitch_class",
      scaleKey: "pitch_classes",
  },
  current_scale_root: {
      name: "Scale Root",
      index: "current_scale_root",
      scaleKey: "root",
  },
  current_chord_root: {
      name: "Chord Root",
      index: "current_chord_root",
      scaleKey: "root",
  },
  current_chord_original_voicing: {
      name: "Chord Original Voicing",
      index: "current_chord_original_voicing",
      scaleKey: "root",
  },
  video_index: {
      name: "Scale Video Index",
      index: "video_index",
      scaleKey: "video_index",
  },
  chord_prime_form: {
      name: "Chord Prime Form",
      index: "chord_prime_form",
      scaleKey: "video_index",
  },
};

export default OutputTypes;
